module.exports = __webpack_public_path__ + "static/media/no-vendor.93dcf3e5.png";